// dateHelpers.js

/**
 * Get the first day of the current month in YYYY-MM-DD format
 * @returns {string} Date string in format YYYY-MM-DD
 */
export function getFirstDayOfMonth() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
}

/**
 * Get the last day of the current month in YYYY-MM-DD format
 * @returns {string} Date string in format YYYY-MM-DD
 */
export function getLastDayOfMonth() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().split('T')[0];
}

/**
 * Get the first day of a specific month
 * @param {Date} date - Date object to get month from
 * @returns {string} Date string in format YYYY-MM-DD
 */
export function getFirstDayOfMonthFromDate(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1).toISOString().split('T')[0];
}

/**
 * Get the last day of a specific month
 * @param {Date} date - Date object to get month from
 * @returns {string} Date string in format YYYY-MM-DD
 */
export function getLastDayOfMonthFromDate(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().split('T')[0];
}

/**
 * Format date for display
 * @param {string|Date} dateString - Date to format
 * @param {Object} options - Formatting options (optional)
 * @returns {string} Formatted date string
 */
export function formatDate(dateString, options = {}) {
  const defaultOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  };
  
  return new Date(dateString).toLocaleDateString('en-US', { ...defaultOptions, ...options });
}

/**
 * Format date to YYYY-MM-DD format
 * @param {Date} date - Date object to format
 * @returns {string} Date string in format YYYY-MM-DD
 */
export function formatDateToISO(date) {
  return date.toISOString().split('T')[0];
}

/**
 * Get current date in YYYY-MM-DD format
 * @returns {string} Today's date in format YYYY-MM-DD
 */
export function getCurrentDate() {
  return new Date().toISOString().split('T')[0];
}

/**
 * Add days to a date
 * @param {Date} date - Base date
 * @param {number} days - Number of days to add
 * @returns {Date} New date with days added
 */
export function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

/**
 * Get date range for current month
 * @returns {Object} Object with startDate and endDate in YYYY-MM-DD format
 */
export function getCurrentMonthRange() {
  return {
    startDate: getFirstDayOfMonth(),
    endDate: getLastDayOfMonth()
  };
}